import { render, staticRenderFns } from "./headerpodat.vue?vue&type=template&id=4d1d612d&scoped=true&"
import script from "./headerpodat.vue?vue&type=script&lang=js&"
export * from "./headerpodat.vue?vue&type=script&lang=js&"
import style0 from "./headerpodat.vue?vue&type=style&index=0&id=4d1d612d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1d612d",
  null
  
)

export default component.exports